module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-SCG.ea32185c.png";